export const INTRO = 'INTRO';
export const PLAYING = 'PLAYING';
export const CORRECT = 'CORRECT';
export const INCORRECT = 'INCORRECT';
export const CONCLUSION = 'CONCLUSION';
export const DONE = 'DONE';
